import { combineReducers } from "redux";
import { Constant } from "../../Constant";

const login = (isPopup = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_LOGIN_POPUP:
            return !isPopup;
        default:
            return isPopup;
    }
};

const reload = (isPopup = false, action) => {
    if (
        action.type.match(/.+_FAIL/) &&
        action.type !== Constant.action.GET_FORM_TEMP.FAIL
    ) {
        // if (action.type.match(/.+_FAIL/)) {
        return true;
    } else {
        return isPopup;
    }
};

const loadForm = (isPopup = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_LOAD_FORM_POPUP:
            return !isPopup;
        default:
            return isPopup;
    }
};

const approverEditLoadForm = (isPopup = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_APPROVER_EDIT_LOAD_FORM_POPUP:
            return !isPopup;
        default:
            return isPopup;
    }
};

const isPopupOpen = combineReducers({ login, reload, loadForm, approverEditLoadForm });

export default isPopupOpen;
